export const ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE =
	'adminTemplatesAndBlueprints';
export const PATH_NAME = '/admin/templates-and-blueprints';
